/**
 * @module "model/answer.model"
 */

define('formkit/model/answer.model',['require','exports','module','underscore','./base.model','./answer.value.model'],function(require, exports, module) {
  //prettier-ignore
  var _                = require('underscore'),
      BaseModel        = require('./base.model'),
      AnswerValueModel = require('./answer.value.model');

  /**
   * @class AnswerModel
   * @augments BaseModel
   */
  var AnswerModel = BaseModel.extend({
    defaults: function() {
      return {
        data: [],
      };
    },

    childModels: {
      data: AnswerValueModel,
    },

    /**
     * Registers a custom setter for the 'data' attribute of an AnswerModel
     *
     * @returns {undefined}
     */

    onBeforeFirstSet: function() {
      BaseModel.prototype.onBeforeFirstSet.apply(this, arguments);

      //Registers a function that is invoked to set the 'data' attribute.  First argument is a function that evaluates
      // if the attribute is the right type and 'shouldSet', the second is a method that manipulates and sets the data accordingly.
      this.registerSetter(
        //"shouldSet" evaluation method
        function(attr, options) {
          if (attr === 'data' && this.get(attr) instanceof Backbone.Collection) {
            return true;
          }
          return false;
        },
        //"set" method resolves all the latest answer values and sets those.
        function(attr, dataArray, options) {
          dataArray = this.mergeAnswerValues(dataArray, this.get(attr), options.requestTimestamp);
          this.get(attr).set(dataArray, _.extend({}, options));
        }
      );
    },

    /**
     * Compares a set of answer values against the answer value collection of a given template object, and
     * will create a 'finalArray' of values to set.  If a later updated value already exists,
     * it it used in place of the current value.  Any later value will also be included to ensure data freshness.
     *
     * @method mergeAnswerValues
     *
     * @param  {Array} dataArray                           Values to set in the answerValueCollection
     * @param  {Backbone.Collection} answerValueCollection A collection of answer values for a template object
     * @param  {number} requestTimestamp                   unix timestamp for the time an dataArray set was created
     * @returns {Array}                                    final resolved array of values to set in the answerValueCollection
     */

    mergeAnswerValues: function(dataArray, answerValueCollection, requestTimestamp) {
      var finalArray = [];
      var foundById = {};

      //cycle through the user's answer values
      _.each(
        dataArray,
        function(dataItem, index) {
          //does an item in the answerValueCollection already exist?
          var existing = answerValueCollection.get(_.result(dataItem, 'id'));
          if (existing) {
            //if an item exists, flag it for reference later
            foundById[existing.id] = true;
            //if an item has been updated later than our user's answer, keep the latest version...
            if (existing.valueUpdateTimestamp >= requestTimestamp) {
              //...then update the hibVersion of the existing item with the latest hibVersion
              finalArray.push({ id: existing.id, hibVersion: dataItem.hibVersion });
            } else {
              //...otherwise, accept the latest answer
              finalArray.push(dataItem);
            }
            //If an item doesn't already exist, add it to the items to save
          } else {
            finalArray.push(dataItem);
          }
        },
        this
      );

      //now cycle through the answer value collection and include all the answers have been updated since requestUpdateTimestamp
      // TODO: understand why this is necessary because we only seem to be saving the the ID of an existing model which should already exist
      answerValueCollection.each(function(model, index) {
        if (!foundById[model.id]) {
          if (model.valueUpdateTimestamp >= requestTimestamp) {
            finalArray.push({ id: model.id });
          }
        }
      }, this);
      return finalArray;
    },
  });

  module.exports = AnswerModel;
});

